import AddButton from "pages/ManagementPage/AddButton/AddButton";

export default AddButton;
